import { Navbar as BaseNavbar } from '@valerahealth/ui-components/layout'
import {
  Link,
  Box,
  SingleSelect,
  MenuItem,
  ClockIcon,
} from '@valerahealth/ui-components/base'
import {
  LanguageSelectV2,
} from '@valerahealth/ui-components/features'
import { languagesShort } from 'locales'
import { Route, Routes } from 'react-router'
import { Progress } from 'routes/Progress'
import {
  enableAppointment,
  timezoneOptions,
} from 'components/onboardingForm/utils'
import { useReduxDispatch, useReduxSelector } from 'store'
import appSlice from 'store/appSlice'
import { useGetScreenSize } from 'hooks/useGetScreenSize'
import { useTranslation } from '@valerahealth/ui-translation'

export const timeZoneShort = {
  'America/Los_Angeles': 'PT',
  'America/Denver': 'MT-CO',
  'America/Phoenix': 'MT-AZ',
  'America/Chicago': 'CT',
  'America/New_York': 'ET',
}

export function TimeZoneSelect() {
  const { t } = useTranslation()
  const timeZone = useReduxSelector((state) => state.app.onboarding.timeZone)
  const dispatch = useReduxDispatch()
  return (
    <SingleSelect
      size="small"
      value={timeZone}
      onChange={(value) => {
        dispatch(appSlice.actions.setTimeZone(value))
      }}
      sx={{ ml: '10px', p: '0px 0px 0px 6px' }}
      startAdornment={<ClockIcon sx={{ mr: '4px' }} />}
      tabIndex={t('timezone')}
    >
      {timezoneOptions.map(({ value: key }) => (
        <MenuItem key={key} value={key}>
          {timeZoneShort[key]}
        </MenuItem>
      ))}
    </SingleSelect>
  )
}

const imgMd = (
  <img
    src="https://cdn.valerahealth.com/images/Valera-Logo-Color-Horiz-RGB-V3.svg"
    alt="Valera Health"
    style={{ height: '40px' }}
  />
)

const imgSm = (
  <img
    src="https://cdn.valerahealth.com/images/Valera-Logo-Standalone-V3.svg"
    alt="Valera Health"
    style={{ height: '40px' }}
  />
)

export const NavbarElement = () => {
  const { size } = useGetScreenSize()
  const image = size > 0 ? imgMd : imgSm

  return (
    <BaseNavbar
      color="transparent"
      position="relative"
      elevation={0}
      sx={{
        width: '100%',
        backgroundColor: (theme) => theme.palette.background.paper,
      }}
      toolbarProps={{
        sx: {
          width: '100%',
          display: 'flex',
          justifyContent: 'start',
          borderBottomStyle: 'solid',
          borderBottomColor: 'ButtonShadow',
        },
      }}
    >
      {size > 1 ? (
        <>
          <Link
            to="https://valerahealth.com"
            target="_blank"
            sx={{
              width: '240px',
              height: 'auto',
              pt: 2,
              pb: 1,
              mr: 'auto',
            }}
          >
            {image}
          </Link>
          <Progress />
          <Box
            sx={{
              display: 'flex',
              width: '240px',
              height: '100%',
              pt: 2,
              pb: 1,
              ml: 'auto',
              justifyContent: 'right',
            }}
          >
            <LanguageSelectV2
              sx={{ ml: 'auto', p: '0px 0px 0px 6px' }}
              languageOptions={languagesShort}
            />
            {enableAppointment && <TimeZoneSelect />}
          </Box>
        </>
      ) : (
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
          <Box sx={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
            <Link
              to="https://valerahealth.com"
              target="_blank"
              sx={{
                width: '240px',
                height: 'auto',
                pt: 2,
                pb: 1,
                mr: 'auto',
              }}
            >
              {image}
            </Link>
            <Box
              sx={{
                display: 'flex',
                width: '240px',
                height: '100%',
                pt: 2,
                pb: 1,
                ml: 'auto',
                justifyContent: 'right',
              }}
            >
              <LanguageSelectV2
                sx={{ ml: 'auto', p: '0px 0px 0px 6px' }}
                languageOptions={languagesShort}
              />
              {enableAppointment && <TimeZoneSelect />}
            </Box>
          </Box>
        </Box>
      )}
    </BaseNavbar>
  )
}

export default function Navbar() {
  const { size } = useGetScreenSize()
  const image = size > 0 ? imgMd : imgSm

  const legacyNavbar = (
    <BaseNavbar
      color="transparent"
      position="relative"
      elevation={0}
      sx={{ width: '100%' }}
      toolbarProps={{
        sx: {
          width: '100%',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          borderBottomStyle: 'solid',
          borderBottomColor: 'ButtonShadow',
        },
      }}
    >
      <Link
        to="https://valerahealth.com"
        target="_blank"
        sx={{
          position: 'absolute',
          top: '0',
          left: '0',
          ml: 2,
          width: '100%',
          height: 'auto',
          maxWidth: '15rem',
          pt: 1,
          pb: 1,
        }}
      >
        {image}
      </Link>
      <Progress />
    </BaseNavbar>
  )

  const legacyHeader = legacyNavbar

  return (
    <Routes>
      <Route path="/patient-onboarding/*" element={<NavbarElement />} />
      <Route path="/self-service/*" element={<NavbarElement />} />
      <Route path="/patient-referral/*" element={legacyHeader} />
      <Route path="/patient-files" element={legacyHeader} />
    </Routes>
  )
}
